import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { MediaService } from "src/app/core/services/media.service";
import { SharedService } from "src/app/core/services/shared.service";

@Component({
  selector: "app-custom-blog",
  templateUrl: "./custom-blog.component.html",
  styleUrls: ["./custom-blog.component.scss"],
})
export class CustomBlogComponent {
  @Input() sortData;
  isSorting: boolean;

  constructor(
    public activeModal: NgbActiveModal,
    public toastr: ToastrService,
    private api: SharedService,
    private mediaApi: MediaService
  ) {}



  closeModal(status) {
    this.activeModal.close(status);
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(
      this.sortData?.list,
      event.previousIndex,
      event.currentIndex
    );
  }

  confirmSort() {
    const pass_data = this.sortData.list.map((ae, i) => ({
      blog_category: ae?.blog_category,
      id: ae.id,
      priority: i,
      is_updated: true,
    }));
    this.isSorting = true;
    this.mediaApi.setUsCategory({ category_data: pass_data }).subscribe(
      (res: any) => {
        this.isSorting = false;
        this.toastr.success("Positions Changed!");
        this.closeModal(true);
      },
      () => {
        this.isSorting = false;
      }
    );
  }
}
